var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inventory"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5943 6.14697H6.7013V9.14697H17.2363V6.14697H19.3433V11.147H21.4503V6.14697C21.4503 5.04697 20.5021 4.14697 19.3433 4.14697H14.9396C14.4972 2.98697 13.3383 2.14697 11.9688 2.14697C10.5992 2.14697 9.44039 2.98697 8.99792 4.14697H4.5943C3.43545 4.14697 2.4873 5.04697 2.4873 6.14697V20.147C2.4873 21.247 3.43545 22.147 4.5943 22.147H10.9153V20.147H4.5943V6.14697ZM11.9688 4.14697C12.5482 4.14697 13.0223 4.59697 13.0223 5.14697C13.0223 5.69697 12.5482 6.14697 11.9688 6.14697C11.3894 6.14697 10.9153 5.69697 10.9153 5.14697C10.9153 4.59697 11.3894 4.14697 11.9688 4.14697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4503 12.647L15.6666 18.147L12.4955 15.147L10.9153 16.647L15.6666 21.147L23.0305 14.147L21.4503 12.647Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/Inventory.d20f74db2a321fe034e46a758daf221b.svg";
export { ForwardRef as ReactComponent };